import React from 'react';
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';
import clock from '../clock.svg'
import coins from '../coins.svg'
import live from '../live.svg'

function QuestionsRow() {

    return (
        <Row id="qRow">
            <Col col="md-4">
                <h3 className="rowTitle">Программа вебинара</h3>
            </Col>
            <Col col="md-8">

                <Row>
                    <Col col={'md-6'}>
                        <div className={'timing'}>
                            <div className={'timing_image'}>
                                <img src={clock} alt={'clock'} height={50}/>
                            </div>
                            <div className={'timing_data'}>
                                <h4>90 минут</h4>
                                <div>продолжительность вебинара</div>
                            </div>
                        </div>
                    </Col>
                    <Col col={'md-6'}>
                        <div className={'timing'}>
                            <div className={'timing_image'}>
                                <img src={coins} alt={'clock'} height={50}/>
                            </div>
                            <div className={'timing_data'}>
                                <h4>Бесплатно</h4>
                                <div>условие участия</div>
                            </div>
                        </div>
                    </Col>
                    <Col col={'md-12'}>
                        <div className={'timing'}>
                            <div className={'timing_image'}>
                                <img src={live} alt={'live'} height={50}/>
                            </div>
                            <div className={'timing_data'}>
                                <h4>Прямая трансляция нанесения</h4>
                                <div>из нашего Учебного центра</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <ul style={{marginTop: '2em'}}>
                    <li className="liQRow">
                        <span>10 основных ошибок на пути к заработку в строительстве на механизации</span></li>
                    <li className="liQRow"><span>Как научиться технологии механизированного нанесения декоративной штукатурки? + Прямая трансляция по нанесению</span>
                    </li>
                    <li className="liQRow"><span>Какое оборудование подходит для механизации? Где его взять?</span></li>
                    <li className="liQRow"><span>Как открыть новое направление в строительстве с минимальными вложениями?</span></li>
                    <li className="liQRow"><span>Как выйти на большие объемы?</span></li>
                    {/*<li className="liQRow"><span>Нюансы договорной работы с заказчиками</span></li>
                    <li className="liQRow"><span>Раскрываем источники, где брать новые заказы</span></li>*/}
                </ul>

            </Col>
        </Row>


    );
}

export default QuestionsRow;
